import { v4 as uuidv4 } from 'uuid';

import { DISTRIBUTION_TYPE_ACTOR } from '../../constants/SmartInsightConstants';
import {
  COLUMNS_DATA_TYPE,
  COLUMNS_IS_NAVIGATION_COLUMN,
  SAVE_ACTIONS,
} from '../constants/editor.constants';

export const getRowsWithRowId = (rows = []) => {
  return rows?.map((item) => ({
    ...item,
    rowId: uuidv4(),
  }));
};

export const modifySavedSearches = (savedSearches = {}) => {
  Object.keys(savedSearches).forEach((searchId) => {
    const { savedSearch } = savedSearches[searchId];

    const searchCriteria = getRowsWithRowId(savedSearch.searchCriteria);
    const columns = getRowsWithRowId(savedSearch.columns);
    const actions = getRowsWithRowId(savedSearch.actions);
    const sort = getRowsWithRowId(savedSearch.sort);

    const modifiedSearch = { ...savedSearch, searchCriteria, columns, actions, sort };

    savedSearches[searchId] = {
      savedSearch: modifiedSearch,
      originalSavedSearch: modifiedSearch,
    };
  });

  return savedSearches;
};

export const getModifiedDistributionRows = ({
  rows = [],
  mappingFields,
  distributionFor,
  isAdmin,
}) => {
  return rows.map((row) => ({
    rowId: uuidv4(),
    id: row[mappingFields.id],
    code: row[mappingFields.code],
    name:
      distributionFor === DISTRIBUTION_TYPE_ACTOR && !isAdmin
        ? `${row.ACT_FIRST_NAME} ${row.ACT_LAST_NAME}`
        : row[mappingFields.name],
  }));
};

export const getColumnsWithTranslations = ({ columns, translateString }) =>
  columns.map((column) => ({
    ...column,
    header: column.header ? translateString(column.header) : '',
  }));

export const getExportColumnsToDisplay = ({ columns, translateString, isDocRepository }) =>
  columns.reduce((acc, column) => {
    if (isDocRepository && column.accessor === COLUMNS_IS_NAVIGATION_COLUMN) {
      return acc;
    }

    return [
      ...acc,
      {
        ...column,
        header: column.header ? translateString(column.header) : '',
      },
    ];
  }, []);

export const getSaveAction = ({ isNew, isSaveAs }) => {
  if (isNew) {
    return SAVE_ACTIONS.CREATE;
  } else if (isSaveAs) {
    return SAVE_ACTIONS.SAVE_AS;
  }

  return SAVE_ACTIONS.EDIT;
};

export const getSavedSearchForSaveAs = ({ savedSearch = {}, newSavedSearchName = '' } = {}) => {
  const modifiedSavedSearch = { ...savedSearch, searchName: newSavedSearchName };

  delete modifiedSavedSearch.id;

  return modifiedSavedSearch;
};

export const getFieldDataType = (fields = [], fieldId = '') => {
  const field = fields.find((field) => field.id === fieldId);

  return field?.dataType;
};

export const modifySavedSearchOnSave = (savedSearch = {}, entityFields = []) => {
  const modifiedColumns = savedSearch.columns?.map((column) => ({
    ...column,
    [COLUMNS_DATA_TYPE]: getFieldDataType(entityFields, column.fieldName),
  }));

  return {
    ...savedSearch,
    columns: modifiedColumns,
  };
};
